module.exports = __webpack_public_path__ + "static/img/service5.2aee082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service5.png
// module id = 3yOV
// module chunks = 0